/**
 * Design tokens for dashboard components
 * These should align with the design system in DESIGN_SYSTEM.md
 *
 * TODO: Migrate these to CSS custom properties in index.css
 * and reference the design system colors
 */

export const DASHBOARD_COLORS = {
  // Brand colors (from design system)
  brand: {
    primary: '#43389b', // Brand primary
    primaryAlt: '#5142c0', // Darker variant
    primaryLight: '#716de7', // Lighter variant
  },

  // Background colors
  background: {
    hero: 'rgba(240, 242, 254, 0.50)',
    cardHighlight: '#f0f2fe',
    cardWhite: '#ffffff',
    neutral: '#fafafa',
  },

  // Text colors
  text: {
    primary: '#252b37',
    secondary: '#717680',
    muted: '#a4a7ae',
    tertiary: '#535862',
  },

  // Border colors
  border: {
    default: '#e9eaeb',
    input: '#716de7',
    subtle: '#d5d7da',
  },

  // Progress/accent colors
  accent: {
    progressBg: '#c7d2fe',
    progressFill: '#5e50da',
    shadowPurple: 'rgba(67, 56, 155, 0.10)',
    inputShadow: '#e2e7fd',
  },
} as const;

export const BRAND_PRIMARY_HEX = DASHBOARD_COLORS.brand.primary;

export const SIDEBAR_COLORS = {
  active: {
    background: '#EDECF8',
    text: '#5142c0',
  },
  inactive: {
    text: '#414651',
  },
  section: {
    divider: '#e9eaeb',
    heading: '#a4a7ae',
  },
} as const;
